import React, { useRef } from 'react';
import classnames from 'classnames';
import DynamicFilterControl from './components/FilterControl';
import useFlexSpacingLayoutInfo, {
  FLEX_ITEM_HORIZONTAL_SPACING,
  FLEX_ITEM_VERTICAL_SPACING,
} from '@gp/hooks/useFlexSpacingLayoutInfo';

import type { IBaseProps } from '@home/types/common';
import type { IRecord } from '@gp/types/global';
import type { IDynamicFilterField } from './types';
import type { IDynamicFilterControl } from './components/FilterControl/types';

import './index.scss';

interface IDynamicFilterProps extends IBaseProps {
  // 筛选器字段集合
  fields: IDynamicFilterField[];
  // 筛选器控件映射
  controls: IRecord<IDynamicFilterControl>;
  // 筛选器value对象
  value?: IRecord<any>;
  // 整个筛选器change的回调
  onChange?: (value: IRecord<any>) => void;
  // 字段change的回调
  onFieldChange?: (key: string, value: any) => void;
  onFieldFocus?: (e?: any) => void;
  onFieldBlur?: (e?: any) => void;
  // 是否需要对比显示高亮
  isNeedDiff?: boolean;
}

const DynamicFilter: React.FC<IDynamicFilterProps> = (props) => {
  const {
    style,
    className,
    fields,
    controls,
    value,
    onChange,
    onFieldFocus,
    onFieldBlur,
    isNeedDiff = false,
    isFilter = false,
    inputSlot, // 筛选器功能插槽：筛选器方案保存
  } = props;
  const root = useRef<HTMLDivElement | null>(null);

  const filterItemsLayoutInfos = useFlexSpacingLayoutInfo(root, fields);

  return (
    <div
      ref={root}
      style={style}
      className={classnames('dbg-dynamic-filter dbg-filterbox', className)}
    >
      {inputSlot}
      {fields
        ?.filter((field) => field?.display ?? true)
        ?.map((field, fieldIndex) => {
          const { style: fieldStyle, className: fieldClassName, key, type, label } = field || {};
          const control = { ...controls?.[key], isNeedDiff } as any;
          const {
            marginRight = FLEX_ITEM_HORIZONTAL_SPACING,
            marginBottom = FLEX_ITEM_VERTICAL_SPACING,
          } = filterItemsLayoutInfos[fieldIndex] || {};

          return (
            <div
              key={key}
              style={{ ...fieldStyle, marginRight, marginBottom }}
              className={classnames('dbg-dynamic-filter__filter-item', fieldClassName, {
                'is-disabled': !!control?.disabled,
              })}
            >
              <DynamicFilterControl
                type={type}
                label={label}
                control={control}
                value={value?.[key]}
                onChange={(payload: any) => {
                  const valueTmp = { ...value, [key]: payload };
                  // onFieldChange?.(key, payload);
                  onChange?.(valueTmp);
                }}
                onFocus={onFieldFocus}
                onBlur={onFieldBlur}
                isFilter={isFilter}
              />
            </div>
          );
        })}
    </div>
  );
};

export default DynamicFilter;
